(ns storrito.fabricjs.object-data
  (:require [storrito.fabricjs.canvas-data :as canvas-data]
            ["fabric" :refer [fabric]]
            [clojure.edn :as edn]
            [storrito.editor-load.migrate :as migrate]
            [goog.object :as obj]))

;; Concept:
;;
;; FabricJS object types like `Image` requires certain default
;; properties. This namespace provides common FabricJS objects that
;; are prefilled with theses default properties. Thereby pure data can
;; be used to construct the desired FabricJS object.
;;
;; Regrettably, it is important to use the FabricJS object
;; constructors. The FabricJS IText constructor for example calculates
;; the width and height of the object based on the text and the font
;; style. The correct width and height is important, if you like to
;; center the object correctly in the middle of the canvas.

(defn image
  "Creates a FabricJS Image."
  [options]
  (-> (js/fabric.Image. (:src options)
                        (clj->js (dissoc options
                                         :src)))
      (canvas-data/canvas-object->clj)
      (assoc :id (:id options))))

(defn itext
  "Creates a new IText FabricJS object as data."
  [options]
  (-> (js/fabric.IText. (:text options)
                        (clj->js (dissoc options
                                         :text)))
      (canvas-data/canvas-object->clj)
      (assoc :id (:id options))))

(defn read-fabricjs-model
  [fabricjs-model-edn-str]
  (-> fabricjs-model-edn-str
      (edn/read-string)
      (migrate/migrate-fabricjs-model)))
